import { render, staticRenderFns } from "./ViewLK.vue?vue&type=template&id=1cd5812e&scoped=true&"
import script from "./ViewLK.vue?vue&type=script&lang=js&"
export * from "./ViewLK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd5812e",
  null
  
)

export default component.exports